Event.prototype.openTargetLink =
    jQuery.Event.prototype.openTargetLink = function (href)
        {
            href = this.currentTarget.dataset.href || href;
            if (this.metaKey)
                window.open(href, '_blank');
            else
                location.href = href;
        };
